import _ from "lodash";
import { SplitFactory } from '@splitsoftware/splitio';
import Cookies from 'js-cookie';
import { datadogLogs } from "@datadog/browser-logs";

const NO_VALUE = 'control';

export default class FeatureService {
  values = {};
  listeners = [];
  isReady = false;

  constructor(values = {}) {
    this.values = values;
  }

  get flags() {
    return Object.keys(this.values);
  }

  init(sdkKey, userKey, mockedFeatures = {}) {
    const self = this;
    const settings = {
      core: {
        authorizationKey: sdkKey,
        trafficType: userKey ? 'user' : 'anonymous',
        key: userKey || this.getAnonymousKey(),
      },
    };

    if ('localhost' === sdkKey) {
      settings.features = mockedFeatures;
    }

    try {
      self.client = SplitFactory(settings).client();

      this.client.on(this.client.Event.SDK_READY, function () {
        self.isReady = true;
        self.updateValues();
      });
      this.client.on(this.client.Event.SDK_UPDATE, function () {
        self.updateValues();
      });
    } catch (error) {
      datadogLogs.logger.error('SplitFactory Error', {}, error);
    }
  }

  getAnonymousKey() {
    return Cookies.get('unauthenticated-session-uuid') || 'anonymous';
  }

  updateValues() {
    if (! this.isReady) {
      return;
    }

    const self = this;
    const treatments = this.client.getTreatmentsWithConfig(this.flags);

    const previousValues = {};
    const newValues = {};

    this.flags.forEach(flag => {
      const previousValue = self.values[flag];
      const value = treatments[flag]?.config
          ? JSON.parse(treatments[flag].config)
          : treatments[flag]?.treatment;

      if (NO_VALUE === value) {
        return;
      }

      if (!_.isEqual(previousValue, value)) {
        previousValues[flag] = previousValue;
        newValues[flag] = value;
        self.values[flag] = value;
      }
    });

    if (!_.isEmpty(newValues)) {
      this.listeners['']?.forEach(listener => listener(newValues, previousValues));

      for (const flag in newValues) {
        this.listeners[flag]?.forEach(listener => listener(newValues[flag], previousValues[flag]));
      }
    }
  }

  onUpdate(listener, flag = '') {
    const key = flag || '';

    if (! this.listeners[key]) {
      this.listeners[key] = [];
    }

    this.listeners[key].push(listener);
  }

  subscribe(flag, listener, defaultValue = null) {
    if (! this.flags.includes(flag)) {
      this.values[flag] = defaultValue;
    }

    this.onUpdate(listener, flag);
    this.updateValues();
  }

  trackEvent(eventName) {
    if (! this.isReady) {
      return;
    }

    this.client.track(eventName);
  }
}
